import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 0;

  h1 {
    margin: 0 0 0 5%;
    font-size: 20px;
    font-weight: 500;
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  margin: 0 4%;
  margin-bottom: 5%;
  font-size: 20px;
  font-weight: normal;

  @media (max-width: 800px) {
    grid-template-columns: 100%;
  }
`;

export const Card = styled.div`
  box-shadow: 1px 1px 3px #aaaaaa;
  margin: 5%;
  padding: 0 0 5% 0;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
  text-align: center;
  line-height: 0.2;

  a {
    text-decoration: none;
    color: black;
  }
`;

export const Image = styled.img`
  width: 120%;
  margin: -5% -5% 0 -5%;
  padding: 0;
`;
